var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8838 13.6753H2.11616C1.22727 13.6753 0.5 12.9214 0.5 11.9999V4.0753C0.5 3.15383 1.22727 2.3999 2.11616 2.3999H14.8838C15.7727 2.3999 16.5 3.15383 16.5 4.0753V11.9999C16.5 12.9214 15.7727 13.6753 14.8838 13.6753ZM2.11616 3.2376C1.71212 3.2376 1.30808 3.65645 1.30808 4.0753V11.9999C1.30808 12.5025 1.71212 12.8376 2.11616 12.8376H14.8838C15.3687 12.8376 15.6919 12.4188 15.6919 11.9999V4.0753C15.6919 3.57268 15.2879 3.2376 14.8838 3.2376H2.11616Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9343 4.7998H0.5V5.6375H15.9343V4.7998Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5323 8.7998H0.5V9.6375H10.5323V8.7998Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5306 10.3999H0.84845V11.2376H10.5306V10.3999Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.a35a9041.svg";
export { ForwardRef as ReactComponent };